import React from 'react';
import { useLocation } from 'react-router-dom';
import { 
  Home, 
  Play,
  Bell,
  Settings,
  Globe,
  BarChart3,
  Lock
} from 'lucide-react';
import NavItem from './NavItem';
import { useSidebar } from './useSidebar';
import { useUser } from '@/lib/contexts/UserContext';

const SidebarNavigation: React.FC = () => {
  const location = useLocation();
  const { expanded } = useSidebar();
  const { needsOnboarding } = useUser();

  // During onboarding, only show Dashboard
  if (needsOnboarding) {
    return (
      <ul className="space-y-1 px-2">
        <NavItem 
          to="/" 
          icon={Home} 
          label="Dashboard" 
          expanded={expanded} 
          active={location.pathname === '/'} 
        />
        {/* Locked navigation items */}
        <div className="opacity-50 cursor-not-allowed">
          <div className={`flex items-center h-10 px-3 text-sm text-muted-foreground ${
            expanded ? 'justify-start' : 'justify-center'
          }`}>
            <Lock className="h-4 w-4" />
            {expanded && <span className="ml-3">Complete onboarding to unlock</span>}
          </div>
        </div>
      </ul>
    );
  }

  return (
    <ul className="space-y-1 px-2">
      <NavItem 
        to="/" 
        icon={Home} 
        label="Dashboard" 
        expanded={expanded} 
        active={location.pathname === '/'} 
      />
      <NavItem 
        to="/runs" 
        icon={Play} 
        label="Runs" 
        expanded={expanded} 
        active={location.pathname.includes('/runs')} 
      />
      <NavItem 
        to="/alerts" 
        icon={Bell} 
        label="Alerts" 
        expanded={expanded} 
        active={location.pathname.includes('/alerts')} 
      />
      <NavItem 
        to="/integrations" 
        icon={Globe} 
        label="Integrations" 
        expanded={expanded} 
        active={location.pathname.includes('/integrations')} 
      />
      <NavItem 
        to="/usage" 
        icon={BarChart3} 
        label="Usage" 
        expanded={expanded} 
        active={location.pathname.includes('/usage')} 
      />
      <NavItem 
        to="/settings" 
        icon={Settings} 
        label="Settings" 
        expanded={expanded} 
        active={location.pathname.includes('/settings')} 
      />
    </ul>
  );
};

export default SidebarNavigation;
